var map = {
	"./ca-es.png": 79,
	"./da.png": 80,
	"./de.png": 81,
	"./el-gr.png": 82,
	"./en-us.png": 83,
	"./en.png": 84,
	"./es-mx.png": 85,
	"./es.png": 86,
	"./et.png": 87,
	"./fi.png": 88,
	"./fr.png": 89,
	"./is.png": 90,
	"./it.png": 91,
	"./lt.png": 92,
	"./nl.png": 93,
	"./no.png": 94,
	"./ru.png": 95,
	"./sv.png": 96
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;